import styled from 'styled-components';
import { GRAYSCALE_800 } from '../../styles/colors';
import { INTER } from '../../styles/fonts';

export const Container = styled.div`
  display: flex;
  flex-direction: row;
  font-family: ${INTER.regular};
  color: ${GRAYSCALE_800};
  width: 90%;
  font-size: 12px;
`;

interface TextProps {
  $bold?: boolean;
}

export const FieldText = styled.span<TextProps>`
  font-family: ${props => props.$bold ? INTER.semiBold : INTER.regular};
`;

export const ValueText = styled.span<TextProps>`
  font-family: ${props => props.$bold ? INTER.semiBold : INTER.regular};
  margin-left: 4px;
`;
